import { render, staticRenderFns } from "./Nicklist.vue?vue&type=template&id=4c3f65c2&"
import script from "./Nicklist.vue?vue&type=script&lang=js&"
export * from "./Nicklist.vue?vue&type=script&lang=js&"
import style0 from "./Nicklist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports